import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import apiClient from './apiClient'; // use centralized axios instance

// ------------------ Thunks ------------------

// Fetch ALL records
export const fetchDCData = createAsyncThunk('dcData/fetchAll', async (_, { rejectWithValue }) => {
  try {
    const response = await apiClient.get('/dcLabData/');
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response?.data || error.message);
  }
});

// Insert a new record
export const insertDCData = createAsyncThunk('dcData/insert', async (dc, { rejectWithValue }) => {
  try {
    const response = await apiClient.post('/dcLabData/', dc);
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response?.data || error.message);
  }
});

// Update an existing record
export const updateDCData = createAsyncThunk('dcData/update', async (dc, { rejectWithValue }) => {
  try {
    const response = await apiClient.put(`/dcLabData/${dc.id}/`, dc);
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response?.data || error.message);
  }
});

// Delete a record by ID
export const deleteDCData = createAsyncThunk('dcData/delete', async (id, { rejectWithValue }) => {
  try {
    await apiClient.delete(`/dcLabData/${id}/`);
    return id;
  } catch (error) {
    return rejectWithValue(error.response?.data || error.message);
  }
});

// ------------------ Slice ------------------
const dcDataSlice = createSlice({
  name: 'dcData',
  initialState: {
    dcData: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Fetch
      .addCase(fetchDCData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDCData.fulfilled, (state, action) => {
        state.loading = false;
        state.dcData = action.payload;
      })
      .addCase(fetchDCData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Insert
      .addCase(insertDCData.fulfilled, (state, action) => {
        state.dcData.push(action.payload);
      })
      .addCase(insertDCData.rejected, (state, action) => {
        state.error = action.payload;
      })

      // Update
      .addCase(updateDCData.fulfilled, (state, action) => {
        const index = state.dcData.findIndex(item => item.id === action.payload.id);
        if (index !== -1) {
          state.dcData[index] = action.payload;
        }
      })
      .addCase(updateDCData.rejected, (state, action) => {
        state.error = action.payload;
      })

      // Delete
      .addCase(deleteDCData.fulfilled, (state, action) => {
        state.dcData = state.dcData.filter(item => item.id !== action.payload);
      })
      .addCase(deleteDCData.rejected, (state, action) => {
        state.error = action.payload;
      });
  },
});

export default dcDataSlice.reducer;
